"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint-disable security/detect-object-injection */

/* eslint-disable react/no-unused-prop-types */

/* eslint-disable react/forbid-prop-types */
var React = require('react');

var withSideEffect = require('react-side-effect');

var PropTypes = require('prop-types');

var Component = React.Component;

var MeliGA = /*#__PURE__*/function (_Component) {
  _inherits(MeliGA, _Component);

  var _super = _createSuper(MeliGA);

  function MeliGA() {
    _classCallCheck(this, MeliGA);

    return _super.apply(this, arguments);
  }

  _createClass(MeliGA, [{
    key: "render",
    value: function render() {
      // Allow the rendering of children elements
      var children = this.props.children;

      if (children) {
        return React.Children.only(children);
      } // Do not render the MeliGA itself in place where it was called
      // since the Analytics code should be always located in specific place of the header


      return null;
    }
  }]);

  return MeliGA;
}(Component);

MeliGA.propTypes = {
  section: PropTypes.string.isRequired,
  secure: PropTypes.bool,
  search: PropTypes.string,
  dimensions: PropTypes.object,
  metrics: PropTypes.object,
  pathFromRoot: PropTypes.array,
  business: PropTypes.string,
  pageVertical: PropTypes.string,
  pageLayout: PropTypes.string,
  pageCategoryL1: PropTypes.string,
  privatePage: PropTypes.string,
  isDeferred: PropTypes.bool,
  enableOptimize: PropTypes.bool,
  optimizeId: PropTypes.string,
  preventOptimizeFlickering: PropTypes.bool,
  children: PropTypes.any
};

function reducePropsToState(propsList) {
  var props = {};
  propsList.forEach(function (currentProps) {
    Object.keys(currentProps).forEach(function (p) {
      if (_typeof(currentProps[p]) === 'object' && !Array.isArray(currentProps[p])) {
        props[p] = _objectSpread(_objectSpread({}, props[p]), currentProps[p]);
      } else {
        // Do not concat the arrays since an order of keys is important
        props[p] = currentProps[p];
      }
    });
  });
  return props;
}

function handleStateChangeOnClient() {
  // Do nothing for now
  return null;
}

function mapStateOnServer(props) {
  return props;
}

module.exports = withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer)(MeliGA);